import script from "./WordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WordComponent.vue?vue&type=script&setup=true&lang=js"

import "./WordComponent.vue?vue&type=style&index=0&id=0cd28f15&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd28f15"]])

export default __exports__